import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconAnswerCorrect = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9999 2.65C6.8296 2.65 2.6499 6.8297 2.6499 12C2.6499 17.1703 6.8296 21.35 11.9999 21.35C17.1702 21.35 21.3499 17.1703 21.3499 12C21.3499 6.8297 17.1702 2.65 11.9999 2.65ZM5.1499 12C5.1499 8.2243 8.2242 5.15 11.9999 5.15C15.7756 5.15 18.8499 8.2243 18.8499 12C18.8499 15.7757 15.7756 18.85 11.9999 18.85C8.2242 18.85 5.1499 15.7757 5.1499 12Z",
		fill: "#00ABFF"
	})
});
export default SvgIconAnswerCorrect;
